import * as React from "react";

import { UnitLayoutingContext, UnitLayoutingContextProvider } from "./Internals/UnitBorderContext/UnitLayoutingContext";
import { UnitIdProvider } from "./UnitIdContext";
import { UnitId } from "./UnitId/UnitId";

export interface SimpleFormUnitProps {
    id: UnitId;
    children: React.ReactNode;
}

const simpleUnitLayoutingContext: UnitLayoutingContext = {
    paddingRight: 30,
    paddingLeft: 30,
};

export function SimpleFormUnit(props: SimpleFormUnitProps): JSX.Element {
    return (
        <UnitIdProvider id={props.id}>
            <UnitLayoutingContextProvider value={simpleUnitLayoutingContext}>
                {props.children}
            </UnitLayoutingContextProvider>
        </UnitIdProvider>
    );
}
